import React from 'react';
import { Modal } from 'react-bootstrap';

import './modals.style.css';

interface Props {
  isShow: boolean;
  title?: string;
  subTitle?: string;
  children?: React.ReactElement;
  onHide: () => void;
}

export class SlideModal extends React.Component<Props> {
  renderTitle(): JSX.Element | null {
    const { title, subTitle } = this.props;

    if (!title && !subTitle) {
      return null;
    }

    return (
      <Modal.Header closeButton>
        <Modal.Title as="h5">
          {title}
          {title && subTitle && <br />}
          {subTitle && <small className="text-muted">{subTitle}</small>}
        </Modal.Title>
      </Modal.Header>
    );
  }

  render() {
    const { isShow, onHide, children } = this.props;

    return (
      <Modal className="modal-slide" show={isShow} onHide={onHide}>
        {this.renderTitle()}
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    );
  }
}
